import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [menuTop, setMenuTop] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    // Calculate menu position based on header height
    const updateMenuPosition = () => {
      const header = document.querySelector('.header');
      if (header) {
        const headerHeight = header.offsetHeight;
        setMenuTop(headerHeight);
      }
    };

    // Update on mount and when menu state changes
    updateMenuPosition();
    
    // Also update after a short delay to ensure DOM is ready
    const timeoutId = setTimeout(updateMenuPosition, 100);
    
    window.addEventListener('resize', updateMenuPosition);
    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener('resize', updateMenuPosition);
    };
  }, [isMobileMenuOpen]);

  // Close menu on navigation
  const handleNavClick = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <header className={`header ${isScrolled ? 'scrolled' : ''}`}>
      <div className="container header-container">
        <div className="logo-quote-group">
          <div className="logo" style={{alignItems:'flex-start',justifyContent:'flex-start'}}>
            <Link to="/" className="logo-text" onClick={handleNavClick}>
              Pro Nurse Legal
            </Link>
          </div>
          <div className="header-quote">
            <span className="header-quote-text">Expert Care. Expert Review. AI-Driven Innovation.</span>
          </div>
        </div>
        <nav 
          className={`nav ${isMobileMenuOpen ? 'nav-open' : ''}`}
          style={menuTop > 0 ? { top: `${menuTop}px` } : {}}
        > 
          <ul className="nav-list">
            <li>
              <Link to="/" className="nav-link" onClick={handleNavClick}>
                Home
              </Link>
            </li>
            {/* Approach hidden for now */}
            {/* <li>
              <Link to="/approach" className="nav-link" onClick={handleNavClick}>
                Approach
              </Link>
            </li> */}
            <li>
              <Link to="/about" className="nav-link" onClick={handleNavClick}>
                About
              </Link>
            </li>
            <li>
              <Link to="/resume" className="nav-link" onClick={handleNavClick}>
                Resume
              </Link>
            </li>
            <li>
              <Link to="/gallery" className="nav-link" onClick={handleNavClick}>
                Gallery
              </Link>
            </li>
            <li>
              <Link to="/business-card" className="nav-link" onClick={handleNavClick}>
                Business Card
              </Link>
            </li>
            <li>
              <Link to="/contact" className="nav-link" onClick={handleNavClick}>
                Contact
              </Link>
            </li>
          </ul>
        </nav>
        <button
          className={`mobile-menu-btn ${isMobileMenuOpen ? 'active' : ''}`}
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          aria-label="Toggle navigation menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>
    </header>
  );
};

export default Header;

